<div *ngIf="isBannerVisible"
     [class.loaded]="isBannerListLoaded"
     class="big-banner">
  <div *ngFor="let image of displayedImages"
       class="banner-image-wrapper">
    <a (click)="businessAction(image.campaignId)"
       [href]="image.link"
       target="_blank">
      <picture>
        <source [media]="BannerMediaQueryThreshold"
                [srcset]="image.additionalImage">

        <img [src]="image.image"
             (load)="businessFocus(image.campaignId)"
             (error)="bannerImageError()"
             alt="Banner Image"
             class="banner-image">

        <div *ngIf="image.advertisement"
             class="banner-image-label">
          реклама
        </div>
      </picture>
    </a>

    <button class="banner-image-close-btn"
            mat-icon-button
            (click)="businessClose(image.campaignId)">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>
